<template>
    <div class="radio-field--content">
        <h4 class="stripe-pay-req-btn--text">{{$t('STRIPE_WALLET_NOTHING_TO_PAY_TODAY', { deliveryDay: firstDeliveryDay })}}</h4>
        <div id="payment-request-button" :class="{'disable-btn': isProcessing}"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PaymentService from '@/services/payments/PaymentService';

let paymentService = new PaymentService();

export default {
    name: 'StripePaymentRequestButton',
    data() {
        return {
            stripe: null,
            paymentRequest: null,
            elements: null,
            prButton: null,
            isProcessing: false,
        };
    },
    mounted() {
        this.initializePaymentRequest();
    },
    props: {
        setupIntent: {
            type: String,
            required: true,
        },
        isUpdate: {
            default: false,
        },
        isGifting: {
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            couponProperties: 'register/getCouponProperties',
            checkoutPrice: 'register/getCheckoutPrice',
            fullName: 'register/getFullName',
            accountFullName: 'account/getFullName',
            userId: 'account/getUserId',
            firstDeliveryDay: 'register/getFirstDeliveryDay',
            paymentGateway: 'payment/getStripeGateway',
        }),
    },
    methods: {
        initializePaymentRequest() {
            this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
            this.paymentRequest = this.stripe.paymentRequest({
                country: 'GB',
                currency: (process.env.VUE_APP_CURRENCY).toLowerCase(),
                requestPayerName: true,
                requestPayerEmail: true,
                displayItems: [
                    {
                        label: 'To be charged on your delivery day',
                        amount: Number(this.checkoutPrice || process.env.VUE_APP_BOX_PRICE) * 100,
                    },
                ],
                total: {
                    label: 'Freddie\'s Flowers (We are authorizing your payment method and the amount you will be paying now is as below)',
                    amount: 0,
                },
            });
            this.elements = this.stripe.elements();
            this.prButton = this.elements.create('paymentRequestButton', {
                paymentRequest: this.paymentRequest,
            });
            this.paymentRequest.canMakePayment().then((result) => {
                if (result) {
                    this.prButton.mount('#payment-request-button');
                } else {
                    document.getElementById('payment-request-button').style.display = 'none';
                }
            });
            this.paymentRequest.on('paymentmethod', (ev) => {
                this.isProcessing = true;
                ev.complete('success');
                if (!ev.paymentMethod?.id) return;
                const paymentToken = ev.paymentMethod.id;
                const cardToken = ev.paymentMethod.id;
                const paymentMethod = ev.paymentMethod?.card?.wallet?.type || ev.paymentMethod?.type || 'wallet';
                const nameOfCard = this.fullName || this.accountFullName;
                this.isUpdate && this.updatePaymentSource(this.userId, paymentToken, cardToken, nameOfCard, paymentMethod);
                this.isOutstandingPayments && this.$emit('pay', ev.paymentMethod.id, ev.paymentMethod?.card?.wallet?.type || ev.paymentMethod.type, this.paymentGateway);
                this.isGifting && this.$emit('save-card-token', paymentToken);
                !this.isUpdate && this.$emit('register', paymentToken, cardToken, paymentMethod, nameOfCard);
            });
        },

        updatePaymentSource(userId, paymentToken, cardToken, nameOfCard, paymentMethod) {
            paymentService.updatePaymentSource(userId, paymentToken, cardToken, nameOfCard, paymentMethod)
                .then(() => {
                    this.$emit('cardUpdated');
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
};
</script>

<style scoped>
    .disable-btn {
        pointer-events: none;
        cursor: not-allowed;
    }
    .stripe-pay-req-btn--text {
        text-align: left;
    }
    .radio-field--content {
        padding: 10px 16px;
        border: 1px solid #DFDFDF;
    }
</style>
